/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_UserApplicationSchema_ } from '../models/PaginatedResponse_UserApplicationSchema_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApplicationsService {
    /**
     * Get user applications
     * Get all active applications accessible to the authenticated user
     * @param userSession
     * @returns PaginatedResponse_UserApplicationSchema_ Successful Response
     * @throws ApiError
     */
    public static getUserApplications(
        userSession?: (string | null),
    ): CancelablePromise<PaginatedResponse_UserApplicationSchema_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applications/',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Direct SAML login to application
     * Initiate IdP-initiated SAML login. Creates a pending auth session and redirects to the IdP page.
     * @param appId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static directSamlLogin(
        appId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applications/{app_id}/saml/direct-login',
            path: {
                'app_id': appId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                302: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Direct OAuth login to application
     * Initiate IdP-initiated OAuth login. Redirects to the SP's initiate_login_uri (OIDC Section 4) or falls back to the app's base URL.
     * @param appId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static directOauthLogin(
        appId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applications/{app_id}/oauth/direct-login',
            path: {
                'app_id': appId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                302: `Successful Response`,
                422: `Validation Error`,
            },
        });
    }
}
